import { useState, type FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { SettingIcon, MoonIcon, LogoutIcon, MessageWithAQuestion } from "@/shared/icons";
import { AppButton, AppNavLink } from "@/shared/Components";
import { useTheme } from "@/services/theme";
import { appRouterPaths } from "@/services/navigation";
import { ModalLogout } from "@/features/modals/ModalLogout";
import { ModalSupport } from "@/features/modals/ModalSupport";
import { useModal } from "@/features/modals/lib";
import { useAuth } from "@/services/auth";
import styles from "./styles.module.scss";

export const HeaderMobileControlButtons: FC = () => {
  const { t } = useTranslation();
  const { showModal, hideModal, isModalOpen } = useModal();
  const { toggleTheme } = useTheme();
  const { logoutHandler } = useAuth();

  const [supportModal, setSupportModal] = useState(false);

  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["separator"]}></div>
        <AppNavLink to={appRouterPaths.settings}>
          {({ isActive }) => {
            return (
              <AppButton
                icon={<SettingIcon className={classNames(styles.setting, styles.icon)} />}
                type="text"
                className={classNames(styles["menu-button"], {
                  [styles.active]: isActive,
                })}
              >
                {t("common.settings")}
              </AppButton>
            );
          }}
        </AppNavLink>
        <AppButton
          icon={<MessageWithAQuestion className={styles.icon} />}
          type="text"
          onClick={() => setSupportModal(true)}
          className={styles["menu-button"]}
        >
          {t("common.support")}
        </AppButton>
        <AppButton
          icon={<MoonIcon className={classNames(styles.theme, styles.icon)} />}
          type="text"
          onClick={toggleTheme}
          className={styles["menu-button"]}
        >
          {t("common.nightMode")}
        </AppButton>
        <div className={styles["separator"]}></div>
        <AppButton
          onClick={showModal}
          icon={<LogoutIcon className={classNames(styles.log, styles.icon)} />}
          type="text"
          className={styles["menu-button"]}
        >
          {t("common.logOut")}
        </AppButton>
      </div>
      <ModalLogout open={isModalOpen} onOk={logoutHandler} onCancel={hideModal} />
      <ModalSupport open={supportModal} onCancel={() => setSupportModal(false)} />
    </>
  );
};
